import { Grid, useEventCallback } from '@mui/material';
import { FormikErrors, FormikTouched } from 'formik';
import { memo } from 'react';
import PmiTextField from 'shell/components/shared/text-field';
import MunicipalityList, {
  MunicipalityAnprVM,
} from 'shell/components/shared/foreign-municipality-list';
import ForeignStateList, { ForeignStateVM } from 'shell/components/shared/foreign-state-list';

export interface ForeignMunicipality {
  stateId?: string;
  stateDescription?: string;
  municipalityId?: string;
  municipalityDescription?: string;
  province?: string;
  istatCode?: string;
}

interface FormForeignEventProps {
  form: ForeignMunicipality | undefined | null;
  handleChange: (form: ForeignMunicipality) => void;
  errors?: FormikErrors<ForeignMunicipality>;
  touched?: FormikTouched<ForeignMunicipality>;
  disabled?: boolean;
}

const FormForeignEventComponent = ({
  form,
  handleChange,
  errors,
  touched,
  disabled,
}: FormForeignEventProps): React.ReactElement => {
  const onChangeForeignState = useEventCallback((state: ForeignStateVM | null | undefined) => {
    handleChange({
      ...(form || {}),
      stateId: state?.id,
      stateDescription: state?.value,
      istatCode: state?.istatCode,
    });
  });

  const onChangeForeignMunicipality = useEventCallback(
    (municipality: MunicipalityAnprVM | undefined) => {
      handleChange({
        ...(form || {}),
        municipalityId: municipality?.id,
        municipalityDescription: municipality?.description,
        province: municipality?.item?.cdNazione,
      });
    }
  );

  return (
    <>
      <Grid item xs={12} md={4}>
        <ForeignStateList
          value={
            form?.stateId
              ? {
                  id: form?.stateId || '',
                  value: form?.stateDescription || '',
                }
              : null
          }
          onChange={onChangeForeignState}
          label="Stato estero"
          id="foreignState"
          error={touched && Boolean(errors)}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <MunicipalityList
          value={
            form?.municipalityId
              ? {
                  id: form?.municipalityId,
                  description: form?.municipalityDescription || '',
                  province: '',
                }
              : null
          }
          disabled={!form?.istatCode || disabled}
          istatCodeState={form?.istatCode}
          onChange={onChangeForeignMunicipality}
          label="Comune estero"
          id="foreignMunicipality"
          error={touched?.municipalityId && Boolean(errors?.municipalityId)}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <PmiTextField
          aria-label="Provincia o Contea"
          label="Provincia/Contea"
          id="foreignProvince"
          name="foreignProvince"
          fullWidth
          type="text"
          variant="outlined"
          value={form?.province || ''}
          error={touched?.province && Boolean(errors?.province)}
          helperText={errors?.province}
          disabled
        />
      </Grid>
    </>
  );
};

FormForeignEventComponent.displayName = 'Form evento estero';

const FormForeignEventMemo = memo(FormForeignEventComponent);

export default FormForeignEventMemo;
